import * as api from "../api"
import * as utils from "../helpers/utils"
import AccountStore from "../stores/AccountStore"
import AppStateStore from "../stores/AppStateStore"
import { IFileDocument } from "../models"
import FileSaver from "file-saver"

export function uploadFile(file: File) {
    let formData = new FormData()
    formData.append("File", file, file.name)
    formData.append("Id", utils.guid())
    formData.append("AccountId", AccountStore.getCurrentAccount().Id)
    formData.append("Name", file.name)
    return api.uploadFile(formData)
        .then(res => res.data)
        .catch(err => {
            AppStateStore.setProgressSnackbarContent(err.data.message)
            return null
        })
}

export function downloadFileWithId(fileDocumentId: string) {
    api.getFile(fileDocumentId).then(res => downloadFile(res.data))
}

export async function downloadFile(fileDocument: IFileDocument) {
    const res = await fetch(`${api_url()}/files/download/${fileDocument.Id}`, {
        method: "POST",
        credentials: "include",
        headers: {
            accept: "application/json, text/plain, */*",
            "accept-language": "en-US,en;q=0.9,es;q=0.8",
            "content-type": "application/json;charset=UTF-8",
        },
    })
    try {
        const blob = await res.blob()
        FileSaver.saveAs(blob, fileDocument.Name)
    } catch (error) {
        AppStateStore.setProgressSnackbarContent(error)
    }
}

export function removeUploadedFile(fileDocumentId: string) {
    return api.removeUploadedFile(fileDocumentId)
}